export default "__VITE_ASSET__c99bbd81__"